import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android app development",
    description: (
      <>
        You can have a suitable{" "}
        <Link to="https://www.tekrevol.com/android-app-development">
          Android app development solution
        </Link>
        according to your business requirements. We develop custom Android apps
        to provide a personalized experience. Using Java, Kotlin, and the latest
        frameworks, we build a full-fledged application. Our Atlanta app
        developers are experienced enough to derive a custom solution that can
        help you scale your business while digitizing the core operations.
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "Iphone app development",
    description: (
      <>
        You will have an incredible solution with our app development in Atlanta
        considering our comprehensive approach to choosing the right stack. In
        our{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          iPhone app development services
        </Link>{" "}
        , we develop high-end native applications using the latest technologies
        such as Objective-C and Swift. Our expert developer ensures that your
        application fulfills the relevant criteria of iOS.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game app development",
    description: (
      <>
        We can bring your imagination to life by providing next-level{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          game app development services
        </Link>{" "}
        .You can consult with our game app developers in Atlanta GA and they
        will give you a clear view of the approach that can make it possible to
        develop an exciting game. Using cutting-edge technologies like VR and
        AR, we facilitate our clients with game development for various
        platforms.
      </>
    ),
  },
  {
    icon: FlutterIcon,
    title: "Flutter app development",
    description: (
      <>
        Leveraging Flutter as a comprehensive framework, we specialize in
        creating feature-rich applications that work seamlessly on both Android
        and iOS platforms. We have a proven track record as a highly reputable
        mobile app development company in Atlanta. Using{" "}
        <Link
          to="/flutter-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Flutter app development
        </Link>{" "}
        , you can achieve a cross-platform application that works on all
        platforms.
      </>
    ),
  },
  {
    icon: HealthcareIcon,
    title: "Healthcare app development",
    description: (
      <>
        With a strong track record in the healthcare industry, we possess
        expertise in crafting versatile healthcare solutions. You can depend on
        our{" "}
        <Link to="https://www.tekrevol.com/healthcare-app-development">
          healthcare app development services
        </Link>{" "}
        in Atlanta to automate various aspects of your healthcare sector. We
        offer advanced healthcare app development incorporating AI-driven
        technologies to tackle intricate processes.{" "}
      </>
    ),
  },
  {
    icon: ReactIcon,
    title: "React Native app development",
    description:
      "As a top-notch React Native app development company, TekRevol leverages the potential of this exceptional framework to produce robust mobile applications that work seamlessly on both Android and iOS platforms. Our skilled team is dedicated to crafting applications that not only meet your specific requirements but also ensure a consistently exceptional user experience across various devices and operating systems.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>
              Our Quality-Enriched Mobile App Development Services in Atlanta
            </h2>
            <p className="impro_para">
              Providing a personalized experience to users is the key to marking
              your territory in the market. Mobile app development in Atlanta is
              all about making businesses accessible for both service providers
              and users. Hence, if you are looking for a reliable mobile app
              development company in Atlanta, we’ve got you covered.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
